<template>
  <ul class="fee-wrapper">
    <li class="fee-item" :aria-label="`Subtotal: $${subtotal}`" tabindex="0">
      <span class="fee-label">Subtotal</span>
      <span class="fee-total">{{ subtotal | toCurrency }}</span>
    </li>
    <li class="fee-item" :aria-label="`Service Fee: $${taxService}`" tabindex="0">
      <span v-if="serviceFee == ' 0.00'" class="fee-label">Tax</span>
      <span v-else class="fee-label"
        >Tax/Service
        <i
          :alt="'Service Fee: $' + serviceFee + ' Tax: $' + taxAmount"
          class="fas fa-info-circle"
          v-tooltip="{ content: taxServiceTooltip, trigger: 'hover click focus', container: false }"
        ></i
      ></span>
      <span class="fee-total">{{ taxService | toCurrency }}</span>
    </li>
    <li class="fee-item" v-if="utensilsApplied" :aria-label="`Utensils Fee: $${utensilsPrice}`" tabindex="0">
      <span class="fee-label">Utensils</span>
      <span class="fee-total">{{ utensilsPrice | toCurrency }}</span>
    </li>
    <li class="fee-item" :aria-label="`Delivery Fee: $${delivery}`" tabindex="0">
      <span class="fee-label">Delivery</span>
      <span class="fee-total">{{ delivery | toCurrency }}</span>
    </li>
    <li class="fee-item" v-if="gratuity" :aria-label="`Gratuity: $${gratuity}`" tabindex="0">
      <span class="fee-label">Gratuity</span>
      <span class="fee-total">{{ gratuity | toCurrency }}</span>
    </li>
    <li class="fee-item" v-if="custIsPayingMinFee" :aria-label="`Minimum Fee: $${minFee}`" tabindex="0">
      <span class="fee-label">Min. Fee</span>
      <span class="fee-total">{{ minFee | toCurrency }}</span>
    </li>
    <li class="fee-item" v-if="couponAdj" :aria-label="`Coupon Adjustment: -$${couponAdj}`" tabindex="0">
      <span class="fee-label">Coupon</span>
      <span class="fee-total">{{ couponAdj | toCurrency(true) }}</span>
    </li>
  </ul>
</template>

<script>
import toCurrency from '../filters/toCurrency'

export default {
  name: 'CartFeeSummary',
  props: {
    subtotal: {
      type: [String, Number],
    },
    taxService: {
      type: [String, Number],
    },
    taxAmount: {
      type: [String, Number],
    },
    serviceFee: {
      type: [String, Number],
    },
    delivery: {
      type: [String, Number],
    },
    gratuity: {
      type: [String, Number],
    },
    couponAdj: {
      type: [String, Number],
    },
    minFee: {
      type: [String, Number],
    },
    custIsPayingMinFee: {
      type: Boolean,
    },
    utensilsApplied: {
      type: Boolean,
    },
    utensilsPrice: {
      type: [String, Number],
    },
  },
  filters: {
    toCurrency,
  },
  computed: {
    taxServiceTooltip() {
      return 'Service Fee: $' + this.serviceFee + ' Tax: $' + this.taxAmount
    },
  },
}
</script>

<style lang="scss" scoped>
.fee-wrapper {
  margin-bottom: 10px;
}

.fee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.fee-label {
  font-size: 1.4rem;
}

.fee-total {
  font-size: 1.4rem;
  font-weight: 700;
  color: $royal;
}
</style>
